<section class="copyForm">
    <div>
        <div class="header">
            <h4 class="copy-modal__title">Копирование урока</h4>
        </div>
        <div class="body">
            <div class="sourceLesson">
                <ul class="copy-modal__info">
                    <li><span>Класс: </span> <b>{{classTitle}}</b>&nbsp;&nbsp; . &nbsp;&nbsp;</li>
                    <li><span>Занятие: </span> № <b>{{lessonNumber}}</b>&nbsp;&nbsp; . &nbsp; &nbsp;</li>
                    <li><span>Дата: </span> <b>{{lessonDate | date: 'dd.MM.yyyy HH:mm'}}</b></li>
                </ul>
            </div>
            <div class="copyIcon">
                <!-- <i class="fa fa-files-o" aria-hidden="true"></i> -->
                <span class="material-icons">arrow_downward</span>
            </div>
            <div class="newLesson">
                <form class="copy-modal__form"
                    [formGroup]="lessonForCopyForm">
                    <div class="row">
                        <div class="el">
                            <label for="studentClass">Класс</label>
                            <select
                                    id="studentClass"
                                    class="copy-modal__input copy-modal__input_select"
                                    formControlName="studentClass"
                                    (change)="onClassChanged()">
                                <option
                                        *ngFor="let studentClass of teacherClasses"
                                        [value]="studentClass.id">
                                    {{studentClass.title}}
                                </option>
                            </select>
                        </div>
                        <div class="el">
                            <label for="lessonNumber">Занятие №</label>
                            <select
                                    id="lessonNumber"
                                    class="copy-modal__input copy-modal__input_select"
                                    formControlName="lessonNumber">
                                <option
                                        *ngFor="let number of availableLessonNumbers"
                                        [value]="number">
                                    {{ number }}
                                </option>
                            </select>
                        </div>
                        <div class="el">
                            <label for="lessonDate">Дата:</label>
                            <input
                                    type="datetime-local"
                                    id="lessonDate"
                                    class="copy-modal__input copy-modal__input_date"
                                    formControlName="lessonDate">
                        </div>
                    </div>
                    <div class="row">
                        <div class="copy-modal__errors"
                                *ngIf="lessonForCopyForm.invalid && lessonForCopyForm.touched">
                            <div class="help-block" *ngIf="lessonForCopyForm.get('studentClass').hasError('required')">
                                Пожалуйста, выберите класс.
                            </div>
                            <div class="help-block" *ngIf="lessonForCopyForm.get('lessonNumber').hasError('required')">
                                Пожалуйста, выберите доступный номер занятия.
                            </div>
                            <div class="help-block" *ngIf="lessonForCopyForm.get('lessonDate').hasError('required')">
                                Пожалуйста, выберите дату занятия.
                            </div>
                        </div>
                    </div>
                    <div class="newLesson-title">
                        <label for="lessonTitle">Название урока</label>
                        <input type="text" id="lessonTitle"
                            class="copy-modal__input"
                            formControlName="lessonTitle" />
                    </div>
                    <div class="newLesson-remarks">
                        <label for="lessonRemarks">Коментарий</label>
                        <textarea type="text" id="lessonRemarks"
                            class="copy-modal__input"
                            formControlName="lessonRemarks"></textarea>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="btns">
        <button
                class="btn modal__button modal__button_cancel"
                type="button"
                (click)="closeCopyModal()">Отмена
        </button>
        <button
                class="btn modal__button modal__button_primary"
                type="button"
                (click)="onSubmit()"
                [disabled]="lessonForCopyForm.invalid">Копировать
        </button>
    </div>
</section>
